// extracted by mini-css-extract-plugin
export var filterIncDec = "_dx-0";
export var leftBorder = "_dx-1";
export var rightBorder = "_dx-2";
export var stringInput = "_dx-3";